/** Compact number display for KPI cards (e.g. 2200 → 2.2k). */
export function formatCompactNumber(value: number): string {
  if (!Number.isFinite(value)) return "0";

  const sign = value < 0 ? "-" : "";
  const abs = Math.abs(value);

  const trim = (n: number) => {
    const rounded = n >= 10 ? n.toFixed(0) : n.toFixed(1);
    return rounded.replace(/\.0$/, "");
  };

  if (abs < 1000) {
    return `${sign}${new Intl.NumberFormat("en-US", { maximumFractionDigits: 0 }).format(abs)}`;
  }
  if (abs < 999_950) return `${sign}${trim(abs / 1000)}k`;
  if (abs < 999_950_000) return `${sign}${trim(abs / 1_000_000)}M`;
  return `${sign}${trim(abs / 1_000_000_000)}B`;
}

export function getCurrencySymbol(currency = "NGN"): string {
  try {
    const part = new Intl.NumberFormat("en", {
      style: "currency",
      currency,
      currencyDisplay: "narrowSymbol",
    })
      .formatToParts(0)
      .find((p) => p.type === "currency");
    return part?.value || currency;
  } catch {
    return currency;
  }
}

export function formatCompactCurrency(value: number, currency = "NGN"): string {
  return `${getCurrencySymbol(currency)}${formatCompactNumber(value)}`;
}

export function formatFullNumber(value: number): string {
  return new Intl.NumberFormat("en-US").format(value);
}

export function formatFullCurrency(value: number, currency = "NGN"): string {
  try {
    return new Intl.NumberFormat("en-NG", {
      style: "currency",
      currency,
      maximumFractionDigits: 0,
    }).format(value);
  } catch {
    return `${getCurrencySymbol(currency)}${formatFullNumber(value)}`;
  }
}
